import BookShow from "components/shared/book/show";
import { serializeReq } from "helpers/form";
import { viewContainer } from "helpers/redux";
import moment from "moment";
import React, { Fragment, lazy, Suspense } from "react";
import { getAllUsersForSelectList } from "sources/admin";
import { config, initialState } from "../formConfig";

const Editor = lazy(() => import("components/shared/editor.js"));

class ShowPopups extends BookShow {
    get dropdActions() {
        return [];
    }

    setValue = ({ value, name }) => {
        const { data, initial } = this.state;
        const nextData = { ...data, [name]: value };
        let shouldUpdate = false;
        for (const key in data) {
            if (initial[key] !== nextData[key]) {
                shouldUpdate = true;
                break;
            }
        }
        if (name === "organizationIds") {
            nextData.userIds = [];
        }
        const isValid = this.isValidForm(nextData);
        this.setState({ data: nextData, shouldUpdate, ...(isValid ? { isValid: true } : {}) });
    };

    apply = () => {
        const { source, match, mergeParams, config } = this.props;
        const { isLoading, shouldUpdate, ...state } = this.state;
        if (!isLoading && shouldUpdate) {
            if (this.isValidForm(state.data)) {
                this.setState({ isLoading: true, isValid: true });
                const serialized = serializeReq({ id: match.params, ...state.data }, config);
                if (serialized.organizationBlockDate) {
                    serialized.organizationBlockDate = moment(serialized.organizationBlockDate).format("YYYY-MM-DD");
                }
                return source
                    .apply(serialized)
                    .then((res) =>
                        res ? this.update(mergeParams) : this.setState({ isLoading: false, isValid: false }),
                    );
            }
            this.setState({ isValid: false });
        }
    };

    renderBody = () => {
        const { config } = this.props;
        const { organizationIds, userIds, roles, text } = this.state.data;
        return (
            <>
                {this.renderField(config.header)}
                <Suspense fallback={<div className="loading" />}>
                    <Editor value={text} onChange={(value) => this.setValue({ name: "text", value })} />
                </Suspense>
                {this.renderCheckbox(config.noWayToClose)}
                {this.renderDateField(config.organizationBlockDate)}
                {this.renderSelect(config.organizationIds)}
                <Fragment key={(organizationIds || []).join(",")}>
                    {this.renderSelect({
                        ...config.userIds,
                        disabled: !organizationIds?.length || roles?.length,
                        url: (params) => getAllUsersForSelectList(params, { organizationId: { in: organizationIds } }),
                    })}
                </Fragment>
                {this.renderSelect({ ...config.roles, disabled: !organizationIds?.length || userIds?.length })}
                {this.renderButton()}
            </>
        );
    };
}

const ConfiguredShow = (props) => <ShowPopups {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "popups");
